module.exports = __webpack_public_path__ + "img/ml.dbd3e220.svg";